import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  realUserFullName?: string | null;
}

export const SubstitutedBy: React.FC<Props> = ({ realUserFullName }) => {
  const { t } = useTranslation();

  if (!realUserFullName) return null;
  return (
    <Typography component="span" variant="body1">
      ({t('common.versions.substitutedBy')} {realUserFullName})
    </Typography>
  );
};
